/* Death, birth and mortuary screens (docs/plans/phase2-mortuary-and-notifications.md §6).
 * Slot tiles follow the bed board (DESIGN.md §8): occupied has an ink outline and the name,
 * free an empty hairline tile, out of service a hatch. States are words plus shapes. Tokens
 * only. */

.page {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}

.meta {
  margin: 0;
  color: var(--graphite);
  font: var(--t-small);
}

.form {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}

.row {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-3);
}

.row > * {
  flex: 1 1 12rem;
  min-width: 0;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-3);
}

.facts {
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: var(--space-2) var(--space-5);
  margin: 0;
}

.facts dt {
  color: var(--graphite);
  font: var(--t-small);
}

.facts dd {
  margin: 0;
  overflow-wrap: anywhere;
}

.prose {
  max-width: 75ch;
  margin: 0;
  white-space: pre-wrap;
  line-height: 1.55;
}

.code {
  margin-right: var(--space-2);
}

.money {
  font-variant-numeric: tabular-nums;
}

.cause {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  padding-bottom: var(--space-4);
  border-bottom: 1px solid var(--rule);
}

.causeTitle {
  margin: 0;
  font: var(--t-body-strong);
}

.list {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  margin: 0;
  padding: 0;
  list-style: none;
}

.listRow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
  min-height: 44px;
  padding: var(--space-2) 0;
  border-bottom: 1px solid var(--rule);
}

.room {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.roomName {
  margin: 0;
  font: var(--t-body-strong);
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(10.5rem, 1fr));
  gap: var(--space-3);
  margin: 0;
  padding: 0;
  list-style: none;
}

.slot {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  min-height: 6.5rem;
  padding: var(--space-3);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-control);
  background: var(--paper);
  color: var(--ink);
  font: var(--t-body);
}

.slot[data-state='occupied'] {
  border: 2px solid var(--ink);
}

.slot[data-state='out_of_service'] {
  background: repeating-linear-gradient(135deg, var(--wash) 0 6px, var(--paper) 6px 12px);
}

.slotLabel {
  font: var(--t-body-strong);
}

.slotState {
  color: var(--graphite);
  font: var(--t-small);
}

.slotName {
  overflow-wrap: anywhere;
}

.slotDays {
  color: var(--graphite);
  font: var(--t-small);
  font-variant-numeric: tabular-nums;
}

.printer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-4);
}

.preview {
  max-width: 100%;
  overflow-x: auto;
}

.printText {
  margin: var(--space-3) 0;
  font: var(--t-body);
}
